var map = {
	"./AlgorandWallet.svg": 3771,
	"./Beacon.svg": 49517,
	"./BeaconBlue.svg": 55611,
	"./BitKeep.svg": 70097,
	"./Keplr.svg": 35371,
	"./Ledger.svg": 35558,
	"./Maiar.svg": 57383,
	"./MetaMask.svg": 40911,
	"./MultiversX DeFi Wallet.svg": 40377,
	"./MyAlgo.svg": 77190,
	"./Sync2.svg": 87258,
	"./TempleWallet.svg": 99926,
	"./TonHub.svg": 50226,
	"./TonKeeper.svg": 55829,
	"./TonWallet.svg": 37545,
	"./Trezor.svg": 54152,
	"./Tron.svg": 97995,
	"./TronLink.svg": 33716,
	"./TrustWallet.svg": 89887,
	"./VeChainThor.svg": 57861,
	"./WalletConnect.svg": 18532,
	"./kukai.svg": 88817,
	"./wallet.svg": 60718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34867;